export function SdkWebsocketSimulatorConfig() {
  return (
    <div className="space-y-2 rounded-lg border border-coval-border bg-surface-default p-4">
      <h3 className="text-sm font-medium text-coval-text">
        Connect with the Coval Python SDK
      </h3>
      <p className="text-sm text-coval-text-muted">
        Run the SDK alongside your voice agent before starting a simulation. It
        fetches connection details for each simulation and opens an outbound
        encrypted WebSocket connection to Coval. Your agent does not need a
        public endpoint or an inbound port.
      </p>
      <p className="text-sm text-coval-text-muted">
        Audio uses mono 16 kHz PCM. Connection settings are managed by the SDK
        rather than stored on this agent.
      </p>
    </div>
  )
}
